import { useCallback, useSyncExternalStore } from "react";
import {
  getServerSnapshotAdminEnvironment,
  readPersistedAdminEnvironment,
  subscribePersistedAdminEnvironment,
  writePersistedAdminEnvironment,
  type AdminEnvironment
} from "../lib/adminEnvironmentStorage.js";

export const usePersistedAdminEnvironment = (): readonly [
  AdminEnvironment,
  (env: AdminEnvironment) => void
] => {
  const environment = useSyncExternalStore(
    subscribePersistedAdminEnvironment,
    readPersistedAdminEnvironment,
    getServerSnapshotAdminEnvironment
  );

  const setEnvironment = useCallback((env: AdminEnvironment) => {
    writePersistedAdminEnvironment(env);
  }, []);

  return [environment, setEnvironment] as const;
};
